import { defaultMapping } from './defaultMapping'
import { combineDataMapping } from './combineDataMapping'
import { applyDataMapping } from './applyDataMapping'
import type { GTMEventDataMapping } from '../GTM.d'
import type { DataLayerInput } from '@corratech/pylot-tag-manager'

type ApplyMapping = (action: DataLayerInput) => DataLayerInput

export const getApplyMapping = (
    customMapping: GTMEventDataMapping
): ApplyMapping => {
    const combinedMapping = combineDataMapping(defaultMapping, customMapping)
    return (action) => {
        return applyDataMapping(action, combinedMapping)
    }
}
